import { useTranslation } from "react-i18next";
import { SIMPLMenuHeader } from "../../../components/commons/header/SIMPLMenuHeader";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
export const NotAuthorized = () => {
const { t } = useTranslation();
  return (
     <SIMPLMenuHeader>
 <div
      data-cy="not-authorized-container"
      className="flex flex-col items-center justify-center h-screen"
    >
  <div className="flex flex-col items-center justify-center gap-2 text-center">
  <WarningAmberIcon className="text-red-600  "fontSize="large" />

  <h1
    data-cy="not-authorized-text"
    className="font-['Arial'] text-[28px] text-danger font-bold leading-[44px] text-center text-Foundation/Heading normal-case [&::first-letter]:uppercase"
  >
    {t("MessageNotAuthorized")}
  </h1>
</div>
    </div>
     </SIMPLMenuHeader>
   
  );
};

